export default function CopyIcon() {
  return (
    <>
      <g id='Copy Icon' clipPath='url(#clip0_3442_197578)'>
        <path
          id='Vector'
          d='M14 12H8C6.89687 12 6 11.1031 6 10V2C6 0.896875 6.89687 0 8 0H12.3781C12.775 0 13.1562 0.159375 13.4375 0.440625L15.5594 2.5625C15.8406 2.84375 16 3.225 16 3.62188V10C16 11.1031 15.1031 12 14 12ZM2 4H5V5.5H2C1.725 5.5 1.5 5.725 1.5 6V14C1.5 14.275 1.725 14.5 2 14.5H8C8.275 14.5 8.5 14.275 8.5 14V13H10V14C10 15.1031 9.10312 16 8 16H2C0.896875 16 0 15.1031 0 14V6C0 4.89687 0.896875 4 2 4Z'
          fill='#A0383F'
          strokeWidth='0.5px'
          stroke='#A0383F'
        />
      </g>
      <defs>
        <clipPath id='clip0_3442_197578'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </>
  );
}
